module.exports = __webpack_public_path__ + "static/media/chat_inactive.a524f1f8.svg";